/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.18",
    versionName: "0.2.0-nightly.2026.4.18",
    versionChannel: "nightly",
    buildDate: "2026-04-18T00:17:46.488Z",
    commitHash: "a2d9ee0f6a32eb4d376213f3a0f10129dc9677a8",
};
